const users = {
  title: "Utilisateurs",
  pageTitle: "Gestion des utilisateurs",
  fullName: "Nom complet",
  pseudo: "Pseudo",
  mail: "Email",
  createdAt: "Créé le",
  type: "Type d'utilisateur",
  userType: {
    cashier: "Caissier",
    user: "Joueur",
    entity: "Entité",
    admin: "Administrateur",
  },
};

export default users;
